import Card from "./Card.js";
import brandIdentity from "../../../data/work/brandIdentity";

function BrandLogo() {
  return (
    <>
      <div className="row">
        {brandIdentity.map((item, key) => {
          return (
            <div key={key} className="col-lg-4 col-md-6">
              <Card pic={item.tb} pdf={item.pdf} />
            </div>
          );
        })}
      </div>
    </>
  );
}

export default BrandLogo;
